/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Report_LeadInputs */

const ja_playdata_report_lead = /** @type {(inputs: Playdata_Report_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2025年版レポートを公開しました。以下のフォームよりお申し込みください。`)
};

const en_playdata_report_lead = /** @type {(inputs: Playdata_Report_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The 2025 report is now available. Fill in the form below and we will send you your free copy.`)
};

/**
* | output |
* | --- |
* | "The 2025 report is now available. Fill in the form below and we will send you your free copy." |
*
* @param {Playdata_Report_LeadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_report_lead = /** @type {((inputs?: Playdata_Report_LeadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Report_LeadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_report_lead(inputs)
	return en_playdata_report_lead(inputs)
});